import { createUseStyles } from 'react-jss';

const styles = {
  subtitle: {
    marginBottom: '4rem',
  },
  form: {
    margin: 0,
  },
  formElements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  input: {
    width: '100%',
  },
  button: {
    width: '100%',
    height: '4.4rem',
  },
  validButtonWrapper: {
    position: 'relative',
    padding: '5rem 0 1rem',
  },
  buttonWrapperWithError: {
    position: 'relative',
    padding: '1rem 0 1rem',
  },
  passwordRecoveryModal: {
    maxWidth: '55rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
